import React from 'react'
import styled from 'styled-components'
import PageHeader, { PageHeaderProps } from './PageHeader'
import TabHeader, { TabItem } from './TabHeader'

const PageContainer = styled.div`
  background: transparent;
  min-height: 100vh;
  padding: 1.5rem;
`

const TabContainer = styled.div`
  background: transparent;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 1.5rem;
`

const TabContent = styled.div`
  background: transparent;
  min-height: 600px;
  padding: 2rem;
  border-radius: 0 0 16px 16px;
`

const ContentArea = styled.div`
  background: transparent;
  min-height: calc(100vh - 200px);
  padding: 2rem;
`

export interface PageLayoutProps {
  children: React.ReactNode
  className?: string
}

export interface PageWithHeaderProps extends PageLayoutProps, PageHeaderProps {}

export interface PageWithTabsProps {
  tabs: TabItem[]
  activeTab: string
  onTabSelect: (key: string | null) => void
  tabContent: React.ReactNode | (() => React.ReactNode)
  children?: React.ReactNode | null
  className?: string
}

// Standard page layout with just content
export const PageLayout: React.FC<PageLayoutProps> = ({ children, className }) => {
  return <PageContainer className={className}>{children}</PageContainer>
}

// Page layout with header
export const PageWithHeader: React.FC<PageWithHeaderProps> = ({
  children,
  className,
  ...headerProps
}) => {
  return (
    <PageContainer className={className}>
      <PageHeader {...headerProps} />
      {children}
    </PageContainer>
  )
}

// Page layout with tabs only (header handled by HeaderRow)
export const PageWithTabs: React.FC<PageWithTabsProps> = ({
  children,
  className,
  tabs,
  activeTab,
  onTabSelect,
  tabContent,
}) => {
  return (
    <PageContainer className={className}>
      <TabContainer>
        <TabHeader tabs={tabs} activeKey={activeTab} onSelect={onTabSelect} />
        <TabContent>{typeof tabContent === 'function' ? tabContent() : tabContent}</TabContent>
      </TabContainer>

      {children && children}
    </PageContainer>
  )
}

export default PageLayout
